import { useState, useEffect, FC, ReactNode } from 'react';
import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';

import Home from './pages/Home';
import TestApplication from './pages/TestApplication';
import Page404 from './pages/Page404';

import Menu from './components/Menu';
import TopNav from './components/TopNav';
import Footer from './components/Footer';
import GameType from './pages/GameType';
import GameView from './pages/GameView';
import BossList from './pages/BossList';
import BossStake from './pages/BossStake';
import BossAirdrop from './pages/BossAirdrop';
import TradeToken from './pages/TradeToken';
import TradeNFT from './pages/TradeNFT';
import TradeHistory from './pages/TradeHistory';
import DocsOverview from './pages/DocsOverview';
import DocsRules from './pages/DocsRules';
import DocsTokenomics from './pages/DocsTokenomics';
import DocsNFTClasses from './pages/DocsNFTClasses';
import DocsMarket from './pages/DocsMarket';
import Dashboard from './pages/Dashboard';

import './css/App.css';
import './css/Game.css';
import './css/Home.css';

// Props interfaces
interface MenuProps {
  sidebarOpen: boolean;
}

interface TopNavProps {
  sidebarOpen: boolean;
  setSidebarOpen: (open: boolean) => void;
}

interface GameTypeProps {
  gameType: 'year' | 'crime' | 'respect';
}

interface GameViewProps {
  gameType: 'year' | 'crime' | 'respect';
}

const App: FC = () => {
  const [splashStatus, setSplashStatus] = useState<string>("active");

  useEffect(() => {
    setSplashStatus("");
  }, []);

  const LayoutLanding: FC = () => {
    return (
      <div>
        <div className={`splash ${splashStatus}`}>
          <div className="splash-icon"></div>
        </div>
        <Outlet />
      </div>
    );
  };

  const LayoutApp: FC = () => {
    const [sidebarOpen, setSidebarOpen] = useState<boolean>(true);

    return (
      <div>
        <div className={`splash ${splashStatus}`}>
          <div className="splash-icon"></div>
        </div>
        <div className="wrapper">
          <Menu sidebarOpen={sidebarOpen} />
          <div className="main">
            <TopNav sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
            <Outlet />
            <Footer />
          </div>
        </div>
      </div>
    );
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LayoutLanding />}>
          <Route index element={<Home />} />
          <Route path="/testapplication/" element={<TestApplication />} />
          <Route path="*" element={<Page404 />} />
        </Route>
        {/* App routes disabled during construction */}
        <Route path="/app" element={<LayoutLanding />}>
          <Route path="*" element={<Home />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;
